import { Box, Stack } from '@storyofams/react-ui';
import { Image } from '@storyofams/storyblok-toolkit';

import { useRouter } from 'next/router';
import { Divider } from '~components';
import { formatDate } from '~lib';
import { Text } from '~components/common/Text';
import { ImageFragmentFragment } from '~lib/storyblok/sdk';
import { ShareButtons } from './ShareButtons';

export const ArticleInfo = ({
  person,
  date,
  image,
  description,
}: {
  person: { name: string; avatar: ImageFragmentFragment };
  date: string;
  image: ImageFragmentFragment;
  description: string;
}) => {
  const { locale } = useRouter();

  return (
    <Box minWidth={['100%', '100%', '180px']}>
      <Stack
        flexDirection={['row', 'row', 'column']}
        space={1.5}
        alignItems={['center', 'center', 'flex-start']}
      >
        <Box
          position="relative"
          size={[40, 64]}
          borderRadius="full"
          overflow="hidden"
          css={{
            '.storyblok-image-wrapper': { width: '100%', height: '100%' },
          }}
        >
          <Image
            alt={person?.avatar?.alt || ''}
            src={person?.avatar?.filename}
            fluid={64}
            fit="cover"
          />
        </Box>

        <Stack
          flexDirection={['column', 'column', 'row']}
          space={[0]}
          justifyContent={['center', 'center', 'flex-start']}
        >
          <Text fontSize={[1.5, 2]}>{formatDate(date, locale, 'MMMM dd')}</Text>
          <Text
            fontSize={[1.5, 2]}
            as="span"
            display={['none', 'none', 'flex!important']}
            px={1}
          >
            -
          </Text>
          <Text fontSize={[1.5, 2]}>By {person?.name}</Text>
        </Stack>
      </Stack>

      <Divider color="grey400" mt={[2, 2, 1.75]} mb={[1.75, 1.75, 2]} />

      <ShareButtons image={image} description={description} />
    </Box>
  );
};
